import React from 'react';
import PropType from 'prop-types';
import PdfGenerationsByIndicationChart from './PdfGenerationsByIndicationChart';
import { IndicationsBreakDownBy } from '../../../util/constants';

PdfGenerationsByIndicationMessageTypeChart.propTypes = {
	filterState: PropType.object,
	colorRegistry: PropType.object,
};

function PdfGenerationsByIndicationMessageTypeChart(props) {
	return <PdfGenerationsByIndicationChart {...props} breakDownBy={IndicationsBreakDownBy.MessageType} configKey='PdfGenerationsByIndicationMessageType' />;
}

export default PdfGenerationsByIndicationMessageTypeChart;
